import React from 'react';
import { carouselTitle, carouselTitleVariants, combineCarouselClasses } from './carousel.styles';
import type { CarouselTitleProps } from './types';

/**
 * CarouselTitle - Semantic heading component for carousel titles
 *
 * Renders proper heading elements (h1-h6) with consistent styling.
 * Supports different heading levels for proper document structure.
 *
 * @example
 * ```tsx
 * <Carousel.Title level={3}>Featured Properties</Carousel.Title>
 * ```
 */
export const CarouselTitle = React.forwardRef<HTMLHeadingElement, CarouselTitleProps>(
  ({ level = 3, children, className, ...restProps }, ref) => {
    const HeadingTag = `h${level}` as keyof JSX.IntrinsicElements;

    const combinedClassName = combineCarouselClasses(carouselTitle, carouselTitleVariants({ level }), className);

    return React.createElement(
      HeadingTag,
      {
        ref,
        className: combinedClassName,
        ...restProps,
      },
      children,
    );
  },
);

CarouselTitle.displayName = 'CarouselTitle';
